<div  *ngIf="isLoading | async" class="overlay">
  <mat-progress-spinner class="circle-spinner"  [color]="color" [diameter]="70" mode="indeterminate">
  </mat-progress-spinner>
</div>
